var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"no-data-text":_vm.noDataText,"items":_vm.items,"loading":_vm.loading,"items-per-page":_vm.itemsPerPage,"hide-default-footer":_vm.hideDefaultFooter,"footer-props":{
    'items-per-page-text': 'Itens por página',
    'items-per-page-all-text': 'Todos',
    'disable-items-per-page': true
  }},scopedSlots:_vm._u([_vm._l((_vm.headers),function(header){return {key:("header." + (header.key)),fn:function(ref){
  var column = ref.column;
return [_vm._t(("header." + (header.key)),function(){return [_c('table-header',{attrs:{"header":header}})]},{"column":column})]}}}),_vm._l((_vm.headers),function(header){return {key:("item." + (header.key)),fn:function(ref){
  var item = ref.item;
return [_vm._t(("item." + (header.key)),function(){return [_c('table-cell',{attrs:{"header":header,"item":item}})]},{"item":item})]}}})],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }